import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

const Clan = ({ data }) => {
  const clanName = "Love2Donate"
  const url = "https://raw.githubusercontent.com/jasonleonhard/img/master/icons/"
  return (
    <Layout>
      <SEO title="Clan" />
      <div className="logoContainer">
        <img className="logo" src={url + clanName + ".png"} alt={clanName} />
      </div>
    </Layout>
  )
}

export default Clan
